import * as Yup from "yup";

const ValidationRegisterBranch = Yup.object({
  businessId: Yup.number().required("El campo es requerido"),
  telefono: Yup.string().required("El campo es requerido"),
  branch: Yup.string().required("El campo es requerido"),
});

export default ValidationRegisterBranch;
